module.exports = __webpack_public_path__ + "static/media/81oUSXkh+TL._AC_SL1500_.62e28093.jpg";